import emptyApi from '@epi-api/emptyApi';
import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { LoadRequestsResponse } from '@epi-models/pages/Reports';
import { TRANSACTIONS_PAGE_SIZE } from '@epi-api/constants';

export const getLoadRequestsRequest = async (
  page: number,
  from: string,
  to: string,
  abortController: AbortController | null = null
): Promise<{ data?: LoadRequestsResponse; error?: any }> => {
  try {
    const response: LoadRequestsResponse | undefined = await get(
      `${config.apiHost}/api/user-transactions/topup-requests-history/lunch/${page}?pageSize=${TRANSACTIONS_PAGE_SIZE}&filterStartDate=${from}&filterEndDate=${to}`,
      undefined,
      undefined,
      abortController?.signal
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const loadRequestsApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getLoadRequests: build.query<
      LoadRequestsResponse,
      {
        page: number;
        from: string;
        to: string;
        abortController: AbortController | null;
      }
    >({
      queryFn: ({ page, from, to, abortController }) =>
        getLoadRequestsRequest(page, from, to, abortController),
      keepUnusedDataFor: 0
    })
  })
});

export const { useGetLoadRequestsQuery, useLazyGetLoadRequestsQuery } =
  loadRequestsApi;
